import React from 'react';
import { useNavigate } from 'react-router-dom';
import EnvironmentSettings from './Components/EnvironmentSettings';
import SidebarPageLayout from './SidebarPageLayout';

function EnvironmentPage() {
  const navigate = useNavigate();

  return (
    <SidebarPageLayout>
      <EnvironmentSettings
        open
        asPage
        onClose={() => navigate('/home')}
      />
    </SidebarPageLayout>
  );
}

export default EnvironmentPage;
